import React from 'react';
import { useParams } from 'react-router-dom';
import { WebsocketProvider } from 'services/WebsocketContext';
import OnlineForm from 'components/OnlineForm';
import { PageBody } from 'modules';
import ClientLogged from 'components/ClientLogged';
import MeetingTypeSelector from 'components/MeetingTypeSelector';

const FormWrapper = () => {
  const { formId } = useParams<{ formId: string }>();

  return (
    <WebsocketProvider formId={formId?.replace(/[,.]/g, '')}>
      <PageBody>
        <ClientLogged />
        <OnlineForm />
        <MeetingTypeSelector />
      </PageBody>
    </WebsocketProvider>
  );
};

export default FormWrapper;
